import { Sidebar } from "../../shared/components";
import { AuthGuard } from "../../shared/guards/AuthGuard";
import { ToolsPagePresentation } from "./components/ToolsPagePresentation";

export const ToolsPage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<ToolsPagePresentation />
			</Sidebar>
		</AuthGuard>
	);
};
